import {Collapse, CollapseProps} from "antd";
import {BulbOutlined} from "@ant-design/icons";
import {colors} from "../../util/colors.ts";

interface FAQProps {
    isPrivateUser: boolean;
}

const nonPrivateClientFAQItems: CollapseProps['items'] = [
    {
        key: '1',
        label: 'Verlängert sich das Inserat automatisch?',
        children: <p>Ihre Anzeige verlängert sich automatisch alle 30 Tage, bis Sie Ihr Inserat deaktivieren oder löschen.</p>
    },
    {
        key: '2',
        label: 'Gibt es Kündigungsfristen bzw. eine Mindestlaufzeit?',
        children: <p>Eine Mindestlaufzeit gibt es nicht, Sie können jederzeit die Inseratsverlängerung beenden, indem Sie die Stelle deaktivieren oder löschen.</p>
    },
    {
        key: '3',
        label: 'Wo kann ich das Inserat deaktivieren oder löschen?',
        children: <p>Das Inserat können Sie in Ihrem Profil unter Meine Stellen deaktivieren oder löschen.</p>
    },
    {
        key: '4',
        label: 'Wo kann ich meine Rechnungsinformationen hinterlegen?',
        children: <p>Im Bezahlvorgang können Sie Ihre Rechnungsadresse angeben, nachdem Sie die Zahlungsmethode
            ausgewählt haben. Klicken Sie dazu das Kästchen "Als Firma einkaufen".</p>
    },
    {
        key: '5',
        label: 'Wann erhalte ich eine Rechnung?',
        children: <p>Nach Zahlungseingang erhalten Sie automatisch eine Rechnung via Email. Sofern Sie per Lastschrift
            zahlen, kann dies bis zu 2 Wochen dauern. Die Rechnung wird an die im silvertalent Profil hinterlegte E-Mail
            Adresse gesendet.</p>
    },
    {
        key: '6',
        label: 'Welche Zahlungsmethoden gibt es?',
        children: <p>Sie können entweder per Kreditkarte, Paypal oder Lastschrift bezahlen.</p>
    },
    {
        key: '7',
        label: 'Wie lange wird meine Stellenanzeige geschaltet?',
        children: <p>Ihre Anzeigen bleiben aktiv, bis Sie sie deaktivieren, löschen oder bis zum Ende der Laufzeit der
            Mitgliedschaft.</p>
    },
    {
        key: '8',
        label: 'Wie werde ich über neue Bewerber informiert?',
        children: <p>Sie erhalten eine Email sobald eine neue Bewerbung eintrifft. Stellen Sie sicher, dass die korrekte
            Email Adresse als Empfänger für Bewerbungen hinterlegt ist.</p>
    },
    {
        key: '9',
        label: 'Wie kann ich mit Bewerbern Kontakt aufnehmen?',
        children: <p>Sie werden per Email informiert, sobald eine neue Bewerbung eintrifft. Über den Link in der Email
            gelangen Sie in Ihr silvertalent Profil und können das Kurzprofil des Bewerbers, dessen Nachricht und,
            sofern freigegeben, dessen private Kontaktdaten einsehen. Sie können den Bewerber dann direkt über
            silvertalent oder ggf. über die angegebene Email und Telefonnummer kontaktieren.</p>
    }
];

const privateClientFAQItems: CollapseProps['items'] = [
    {
        key: '1',
        label: 'Welche Zahlungsmethoden gibt es?',
        children: <p>Sie können entweder per Kreditkarte, Paypal oder Lastschrift bezahlen.</p>
    },
    {
        key: '2',
        label: 'Wie lange wird meine Stellenanzeige geschaltet?',
        children: <p>Die Stellenanzeige hat eine Laufzeit von 30 Tagen.</p>
    },
    {
        key: '3',
        label: 'Wie werde ich über neue Bewerber informiert?',
        children: <p>Sie erhalten eine Email sobald eine neue Bewerbung eintrifft. Stellen Sie sicher, dass die korrekte
            Email Adresse als Empfänger für Bewerbungen hinterlegt ist.</p>
    },
    {
        key: '4',
        label: 'Wie kann ich mit Bewerbern Kontakt aufnehmen?',
        children: <p>Sie werden per Email informiert, sobald eine neue Bewerbung eintrifft. Über den Link in der Email
            gelangen Sie in Ihr silvertalent Profil und können das Kurzprofil des Bewerbers, dessen Nachricht und,
            sofern freigegeben, dessen private Kontaktdaten einsehen. Sie können den Bewerber dann direkt über
            silvertalent oder ggf. über die angegebene Email und Telefonnummer kontaktieren.</p>
    }
];

const trustLogos = [
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cc914517c983d81255710_Caritas_logo.svg', alt: 'Caritas'},
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cb011960dbac18384fbea_9a618d560a92834fa18fea6e8db5e330_dhl_logo.png', alt: 'DHL'},
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cc63d627a4dfa6f8c7cc5_a3cb4f36a68ae4c6d33213f79a8c59f6_edeka.png', alt: 'Edeka'},
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cc747b47cd759be51afe3_Studienkreis_Logo_negativ_rot.jpg', alt: 'Studienkreis'},
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cc8901c82b3bc27b20138_mpg-new_0.png', alt: 'MPG'},
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cc7e3d74da5a6164412c3_Screenshot%202026-01-30%20at%2016.01.40.png', alt: 'Partner'},
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cc8c899b1b2f9b4ee691f_Hyatt_Logo.png', alt: 'Hyatt'},
    {src: 'https://cdn.prod.website-files.com/6349643fd2f3b444e2051120/697cb01191f7436b719bb04d_DKGlogo.jpg', alt: 'DKG'},
];

export const FAQ = ({isPrivateUser}: FAQProps) => {
    const items = isPrivateUser ? privateClientFAQItems : nonPrivateClientFAQItems;

    return (
        <div>
            <div style={{textAlign: 'center', marginBottom: 40}}>
                <h2 style={{marginBottom: 24}}>
                    silvertalent ist Deutschland's größte Job Plattform für Ü60 Fachkräfte.
                    <br/>
                    Diese Firmen vertrauen auf uns
                </h2>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 24,
                }}>
                    {trustLogos.map((logo) => (
                        <img
                            key={logo.alt}
                            src={logo.src}
                            alt={logo.alt}
                            style={{
                                height: 50,
                                maxWidth: 120,
                                objectFit: 'contain',
                            }}
                        />
                    ))}
                </div>
            </div>

            <h2>
                <BulbOutlined style={{color: colors.main, marginRight: 8}}/> Häufige Fragen
            </h2>
            <Collapse items={items} className="w-full"/>
        </div>
    );
};
